import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
} from 'react-hook-form'
import { FormInput } from '../../../../components/forms/input/FormInput'
import { FormSelect } from '../../../../components/forms/select/FormSelect'
import { AppCatalogos,} from '../../../../utils/Constantes'
import { BaseSyntheticEvent } from 'react'
import { Opcion } from '../../../../models/catalogo.type'
import { TAutorizacionForm } from '../../models/autorizacionForm.type'

type Props = {
  isPorFechaVencimiento: boolean | undefined
  isAutorizacionIndefinida: boolean | undefined
  calcularFechaCantidad: () => void
  usuarioPermiso?: boolean
  control: Control<TAutorizacionForm>
  errors: FieldErrors<TAutorizacionForm>
  register: UseFormRegister<TAutorizacionForm>
}
export const DatosAutorizacionFormPorDuracion = ({
  isAutorizacionIndefinida,
  isPorFechaVencimiento,
  calcularFechaCantidad,
  usuarioPermiso,
  control,
  errors,
  register,
}: Props) => {
  // Campos de captura de vigencia por "duracion" (cantidad + unidad).
  // Se ocultan cuando la autorizacion es indefinida o cuando se eligio capturar por fecha.

  return (
    <div
      className='col-4 mb-7 '
      style={!isAutorizacionIndefinida && isPorFechaVencimiento ? { display: 'none' } : {}}>
      <label
        className='form-label fs-4   '
        style={isAutorizacionIndefinida || isPorFechaVencimiento ? { display: 'none' } : {}}>
        Duración
        <span className='text-danger'>
          {!isPorFechaVencimiento && !isAutorizacionIndefinida ? '*' : ''}
        </span>
      </label>
      <div className='d-flex '>
        <div
          className='col-4 me-3'
          style={isPorFechaVencimiento || isAutorizacionIndefinida ? { display: 'none' } : {}}>
          <Controller
            control={control}
            name='cantidadDuracion'
            render={({ field: { onChange } }) => (
              <FormInput
                tipo='number'
                min={0}
                disabled={isAutorizacionIndefinida || isPorFechaVencimiento || !usuarioPermiso}
                nombreCampo='cantidadDuracion'
                register={register}
                placeholder={'Ej.5'}
                isObligatorio={isAutorizacionIndefinida || isPorFechaVencimiento ? true : false}
                tipoFiltro='texto'
                onChange={(e: BaseSyntheticEvent) => {
                  onChange(e)
                  calcularFechaCantidad()
                }}
              />
            )}
          />
          {errors && errors['cantidadDuracion'] && (
            <p className='text-danger text-end fs-5'>{errors['cantidadDuracion']?.message}</p>
          )}
        </div>

        <div
          className='flex-grow-1'
          style={isPorFechaVencimiento || isAutorizacionIndefinida ? { display: 'none' } : {}}>
          <Controller
            control={control}
            name='unidadDuracion'
            render={({ field: { onChange, value } }) => (
              <FormSelect
                isDisabled={isAutorizacionIndefinida || isPorFechaVencimiento || !usuarioPermiso}
                nombreCampo='unidadDuracion'
                isObligatorio={true}
                value={value}
                elementos={AppCatalogos.CAT_UNIDAD_DURACION_AUTORIZACION}
                onChange={(e: Opcion) => {
                  onChange(e)
                  calcularFechaCantidad()
                }}
                placeholder={
                  isAutorizacionIndefinida
                    ? 'Sin unidad'
                    : isPorFechaVencimiento
                    ? 'Unidad'
                    : 'Ej.Días'
                }
                errors={errors}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}
